import React from 'react'
import { useTableConfig } from 'modules/Forms/Referral/LinkForm/subcomponents/FinancialTerms/subcomponents/Table/hooks/useTableConfig'
import { List } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import styles from 'modules/Forms/Referral/LinkForm/subcomponents/FinancialTerms/financial-terms.module.scss'

export const Table = ({ rates, isEditForm }) => {
  const { tableState, tableConfig } = useTableConfig(
    {
      isEditForm,
    },
    [...rates].sort(
      (
        { financial_profile_type_alias: a },
        { financial_profile_type_alias: b },
      ) => (a > b ? 1 : b > a ? -1 : 0),
    ),
  )

  return (
    <div
      className={clsx(
        styles['financial-terms__table-wrapper'],
        'margin-top-24',
      )}
    >
      <List table={tableState} config={tableConfig} />
    </div>
  )
}

Table.propTypes = {
  rates: PropTypes.array,
  isEditForm: PropTypes.bool,
}
